import { FC, useEffect } from 'react'
import shallow from 'zustand/shallow'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { useTalentsSeasonSettings } from '../../../graphql/talents-season/useTalentsSeasonData'
import { TalentsSeasonYearDto } from '../../../types'
import { useCultivatingTalentsStore } from '../../cultivatingTalents/CultivatingTalentsStore'
import { TalentsSeasonTabContent } from './TalentsSeasonTabContent'

interface TalentsSeasonTabProps {
  talentsSeasonYear: TalentsSeasonYearDto
  previousSeasonExist: boolean
  isHRSettings: boolean
  isAllCompaniesSettings: boolean
  isYourCompanyView: boolean
}

export const TalentsSeasonTab: FC<TalentsSeasonTabProps> = ({
  talentsSeasonYear,
  previousSeasonExist,
  isHRSettings,
  isAllCompaniesSettings,
  isYourCompanyView,
}) => {
  const { companyId, country, year } = talentsSeasonYear
  const [setTalentsSeasonSettings, activeSeasonKey, talentsSeasonSettings] = useCultivatingTalentsStore(
    (state) => [state.setTalentsSeasonSettings, state.activeSeasonKey, state.talentsSeasonSettings],
    shallow,
  )

  const [getTalentsSeasonSettings, { data, error, loading }] = useTalentsSeasonSettings()

  const settings = data && data.talentsSeasonSettings ? data.talentsSeasonSettings : undefined

  useEffect(() => {
    getTalentsSeasonSettings({ variables: { companyId, country, year } })
  }, [getTalentsSeasonSettings, companyId, country, year, activeSeasonKey])

  useEffect(() => {
    if (settings && activeSeasonKey === settings.year.toString()) {
      setTalentsSeasonSettings(settings)
    }
  }, [settings, setTalentsSeasonSettings, data, activeSeasonKey])

  if (loading || error || !data || !data.talentsSeasonSettings || !talentsSeasonSettings) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data || !data.talentsSeasonSettings} error={error} showSpinner />
  }

  return (
    <TalentsSeasonTabContent
      previousSeasonExist={previousSeasonExist}
      isHRSettings={isHRSettings}
      isAllCompaniesSettings={isAllCompaniesSettings}
      isYourCompanyView={isYourCompanyView}
    />
  )
}
